import Moment from 'moment';
import * as Cart from './cartHelper';
import { fromJS } from 'immutable';
export function toJS(immutable) {
  if (immutable && immutable.toJS) {
    return immutable.toJS()
  }
  return immutable;
}

export function isUrl(url) {
  var regexp = /(http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/
  return regexp.test(url);
}

export function trimByCharsLimit(string, maxLength) {
  var trimmedString = string.substr(0, maxLength);
  return trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(" ")));
}

export function cleanCoordinates(arr) {
  //console.log(arr);
  return arr
    ? {
      longitude: arr[0],
      latitude: arr[1]
    }
    : undefined;
}

export function addHTTP(url) {
  if (!/^https?:\/\//i.test(url)) {
    url = 'http://' + url;
  }
  return url;
}

export function numberToArray(num) {
  var arr = []
  for (var i = 0; i < num + 1; i++) {
    arr.push(i);
  };
  return arr;
}

export function isPhoneNumberValid(phone) {
  //return /^(\+\d{1,3}[- ]?)?\d{10}$/.test(phone)
  return /^[2-9]\d{9}$/.test(phone)
}

export function isEmailValid(email) {
  return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)
}

export function arraysEqual(arr1, arr2) {
  if (arr1.length !== arr2.length)
    return false;
  for (var i = arr1.length; i--;) {
    if (arr1[i] !== arr2[i])
      return false;
    }
  return true;
}

export function toTitleCase(str) {
  return str.replace(/\w\S*/g, function(txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}

export function isAllocatedProduct (price) {
  if(price) {
    return (price.toString().substr(-3) == ".95")
  }
  return false;
}

export function isRecommendedProduct (product) {
  return product.Description.match(/^REAL LEMON $|^ICE$|^SOLO CUPS$/g);
}


export function calculateAge(inputdob) {

    var age;

    //regular expression to validate date formate mm/dd/yyyy
    var rex = /^(0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])[- /.](19|20)\d\d+$/;

    if (!rex.test(inputdob)) {
        return _buildData(age, 'Date must be of mm/dd/yyyy format', 1);
    }

    var diffms = new Date - new Date(inputdob);
    age = Math.floor(diffms / (365.25 * 1000 * 60 * 60 * 24));

    return _buildData(age, age + ' Years', 0);

    function _buildData(age, message, status) {
        return { "age": age, "message": message, "status": status }
    }
}

export function chunkArrayInGroups(arr, size) {
  arr = !arr ? [] : arr;
  var chunkedArray = [];
  for(var i = 0; i < arr.length; i += size) {
    chunkedArray.push(arr.slice(i, i+size));
  }
  return chunkedArray;
}

export function addToCart(product = {}, quantity = 1) {
  return new Promise((resolve, reject) => {
    if (!product) {
        reject({
          title: 'Something went wrong!'
        });
        return;
    
    }

    let productQuantity = 0;
    let isItemAddedToCart = !!Cart.isProductExist(product._id);
    if (isItemAddedToCart) {
      let storedProduct = Cart.getCartAttribute(Cart.ATTRIBUTE_CART_ITEM, { id: product._id })
      productQuantity = parseInt(storedProduct.quantity);
    }


    if (((product['Qty'] == 0) || (quantity + productQuantity) > product['Qty'])) {
      reject({ title: 'We are in the process of restocking this item!' });
      return;
    }


    if (isAllocatedProduct(product['PriceB'].toFixed(2))) {
      reject({ title: 'DUE TO HIGH DEMAND ON THIS ITEM, PLEASE CONTACT US TO REQUEST THIS OFFER (213) 485-9463' });
      return;
    }

    let copyOfProduct = toJS(fromJS(product));
    copyOfProduct.quantity = productQuantity + (quantity ? quantity : 1);
    if (copyOfProduct.PriceB !== undefined) {
      const parsedPriceB = Number(copyOfProduct.PriceB);
      if (!Number.isNaN(parsedPriceB)) {
        copyOfProduct.PriceB = parsedPriceB;
      }
    }
    Cart.modifyCartAttribute(Cart.ATTRIBUTE_CART_ITEM, {
      id: product._id,
      details: copyOfProduct
    });
    resolve();
  });
}


// WEBPACK FOOTER //
// ./src/utils/utils.js